<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-xl mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <form class="flex flex-col gap-5 h-full" [formGroup]="formEditEmployee">
      <div class="p-5">
        <div class="flex items-center justify-between self-start pb-4 border-b border-b-chathams-blue-400 w-full">
          <h4 class="text-chathams-blue-500 text-xl font-semibold">Detalhes do Colaborador</h4>
          <button
            type="button"
            class="w-12 h-10 rounded-sm btn--secondary"
            (click)="fechar()"
            aria-label="Fechar edição de colaborador"
          >
            X
          </button>
        </div>
        <div class="w-full flex flex-col pt-6 gap-5">
          <div class="flex flex-col gap-5">
            <div class="flex gap-6">
              <div class="form-group basis-2/3">
                <label for="edit-employee-name" class="input-label">Nome*</label>
                <input type="text" class="form-input" formControlName="name" id="edit-employee-name" />
              </div>
              <div class="form-group basis-1/3">
                <label for="edit-employee-registration" class="input-label"
                  >ID Externo / Matrícula{{ matriculaObrigatoria ? '*' : '' }}</label
                >
                <input
                  type="text"
                  class="form-input"
                  formControlName="registrationNumber"
                  id="edit-employee-registration"
                />
              </div>
            </div>
            <div class="flex gap-6">
              <div class="form-group basis-2/3">
                <label for="edit-employee-email" class="input-label">E-mail*</label>
                <input type="email" class="form-input" formControlName="email" id="edit-employee-email" />
              </div>
              <div class="form-group basis-1/3">
                <label for="edit-employee-document" class="input-label">CPF*</label>
                <input
                  type="text"
                  class="form-input"
                  formControlName="document"
                  id="edit-employee-document"
                  mask="000.000.000-00"
                />
              </div>
            </div>
          </div>
          <div class="flex gap-6">
            <div class="form-group basis-1/3">
              <label for="edit-employee-phone" class="input-label">Celular*</label>
              <input
                type="text"
                class="form-input"
                formControlName="phone"
                id="edit-employee-phone"
                mask="(00) 0000-0000||(00) 00000-0000"
              />
            </div>

            <div class="form-group basis-1/3">
              <label for="edit-employee-status" class="input-label">Situação do colaborador*</label>
              <ng-select
                labelForId="edit-employee-status"
                notFoundText="Nenhum item encontrado"
                [items]="opcoesStatus"
                [searchable]="true"
                formControlName="status"
                bindLabel="label"
                [multiple]="false"
                bindValue="value"
                appendTo="body"
              >
              </ng-select>
              <small class="text-xs text-chathams-blue">Desligado bloqueia o login por matrícula no totem.</small>
            </div>

            <div class="form-group basis-2/3">
              <label for="edit-employee-role" class="input-label">Função*</label>
              <input type="text" id="edit-employee-role" class="form-input" formControlName="role" />
            </div>
          </div>
          <div class="flex gap-6">
            <div class="form-group basis-1/3">
              <label for="edit-employee-subsidiary" class="input-label">Filial*</label>
              <ng-select
                labelForId="edit-employee-subsidiary"
                notFoundText="Nenhum item encontrado"
                [items]="opcoesFiliais"
                [searchable]="true"
                formControlName="subsidiaryId"
                bindLabel="name"
                [multiple]="false"
                bindValue="id"
                appendTo="body"
                (change)="changeFilial()"
              >
              </ng-select>
            </div>
            <div class="form-group basis-2/3">
              <label for="edit-employee-cost-center" class="input-label">Centro de Custo*</label>
              <ng-select
                labelForId="edit-employee-cost-center"
                notFoundText="Nenhum item encontrado"
                [items]="opcoesCentroCustos"
                [searchable]="true"
                formControlName="costCenterId"
                bindLabel="description"
                [multiple]="false"
                bindValue="id"
                appendTo="body"
              >
              </ng-select>
            </div>
          </div>
          <div class="flex items-center gap-6 mt-4">
            <button
              type="button"
              (click)="resendAccessApp()"
              class="btn btn--secondary px-4 shrink-0 whitespace-nowrap"
            >
              Enviar acesso à carteirinha de saúde
            </button>
            <small class="text-xs text-chathams-blue">
              Sem acesso: cria o acesso e envia o e-mail de ativação. Com acesso: envia um e-mail para criar nova senha.
            </small>
          </div>
          <div class="flex justify-end">
            <button
              *isAllowed="[ERoleAdminString.Admin, 'employee.update', 'employee.edit']"
              type="button"
              class="px-6 btn btn--secondary"
              [disabled]="salvando"
              (click)="editEmployee()"
            >
              Salvar Cadastro
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
